import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserProvider} from "./components/Contexts/UsersContext";
import { EnrolleeProvider } from "./components/Contexts/EnrolleeContext";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";
import { AlertProvider } from "./components/Contexts/AlertContext";
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ReactGA.initialize("G-840KQ7R832");
ReactGA.send({
 hitType: "pageview",
 page: window.location.pathname,
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <EnrolleeProvider>
        <UserProvider>
          <AlertProvider>
            <App />
          </AlertProvider>
        </UserProvider>
      </EnrolleeProvider>
    </BrowserRouter>
    ,
  </React.StrictMode>
);

reportWebVitals();
